import { NotFoundPage } from "@redotech/redo-web/login/not-found-page";
import { isNotFoundRouteError } from "@redotech/redo-web/login/not-found-route-error";
import { memo, useEffect } from "react";
import { useLocation, useRouteError } from "react-router-dom";
import { RouteStateMarker } from "./route-state-marker";

const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/;

export const MerchantApp404Page = memo(function MerchantApp404Page() {
  const location = useLocation();
  const error = useRouteError();
  const isNotFoundError = isNotFoundRouteError(error);
  const isChunkLoadError =
    error instanceof Error && CHUNK_LOAD_ERROR.test(error.message);

  // At most one reload per 10 s, so a chunk that is still missing after the
  // reload shows this page instead of looping.
  useEffect(() => {
    if (!isChunkLoadError) {
      return;
    }
    const lastReload = Number(sessionStorage.getItem("chunk-load-reload"));
    if (Date.now() - lastReload < 10_000) {
      return;
    }
    sessionStorage.setItem("chunk-load-reload", String(Date.now()));
    window.location.reload();
  }, [isChunkLoadError]);

  return (
    <>
      <RouteStateMarker
        path={location.pathname}
        state={isNotFoundError ? "not-found" : "error"}
      />
      <NotFoundPage />
    </>
  );
});
